import { memo } from "react";
import { cn } from "@/lib/utils";
import { PROVIDER_META, type AiProvider } from "@/types/ai-chat";

type ToolId = "claude" | "codex" | "gemini";

const TOOL_PROVIDER: Record<ToolId, AiProvider> = {
  claude: "claude-code",
  codex: "codex",
  gemini: "gemini",
};

const TOOL_HOVER: Record<ToolId, string> = {
  claude: "hover:bg-orange-500/[0.08] hover:text-orange-300",
  codex: "hover:bg-emerald-500/[0.08] hover:text-emerald-300",
  gemini: "hover:bg-blue-500/[0.08] hover:text-blue-300",
};

const TOOL_TITLE: Record<ToolId, string> = {
  claude: "Open Claude Code",
  codex: "Open Codex",
  gemini: "Open Gemini",
};

const TOOLS = (["claude", "codex", "gemini"] as ToolId[]).map((id) => ({
  id,
  ...PROVIDER_META[TOOL_PROVIDER[id]],
  hoverClass: TOOL_HOVER[id],
  title: TOOL_TITLE[id],
}));

export const ToolLauncherButtons = memo(function ToolLauncherButtons({
  onLaunch,
}: {
  onLaunch: (tool: ToolId) => void;
}) {
  return (
    <div className="flex items-center gap-0.5">
      {TOOLS.map((tool) => (
        <button
          key={tool.id}
          type="button"
          onClick={() => onLaunch(tool.id)}
          className={cn(
            "flex items-center gap-1 px-2 py-1 text-[11px] font-medium text-zinc-500 rounded transition-colors",
            tool.hoverClass
          )}
          title={tool.title}
        >
          <img src={tool.logo} className="w-3 h-3 opacity-70" alt="" />
          <span>{tool.label}</span>
        </button>
      ))}
    </div>
  );
});
